<template>
  <div class="mywork" ref="myworkWrapper" @scroll="scroll">
    <div v-if="this.hasPerfectedUserInfo">
      <div class="headimg">
        <div class="useinfo">
          <div class="useimg">
            <img v-lazy="powericon" alt />
          </div>
          <div class="allinfo">
            <div class="infotop">
              <div class="namegrade">
                <span class="usename">{{ this.userInfo.userName }}</span>
                <!-- <span class="usegrade">{{ this.userInfo.userGrade }}</span> -->
              </div>
              <div class="btn-wrapper">
                <div class="modifyingdata" @click="modifyingdata">修改资料</div>
                <Button
                  btnText="我的证书"
                  btnType="orange"
                  :count="myCertTipsCount"
                  @click="handleJumpCertGroup"
                  v-if="showMyCertButton"
                ></Button>
              </div>
            </div>
            <div class="useaddress" style="display:none;">{{ userUnit }}</div>
          </div>
        </div>
        <div class="totalverify">
          <div class="allverify">
            项目总数
            <span>{{ userInfo.worksNum | NumFormat }}</span>
          </div>
          <div class="separate" v-if="!hidePraise">|</div>
          <div class="allverify" v-if="!hidePraise">
            点赞总数
            <span>{{ userInfo.likeNum | NumFormat }}</span>
          </div>
        </div>
      </div>
      <!-- console.log(item.defaultOptions.filter(function(elem){return elem.option == "NAME"})[0].value) -->
      <div class="verifylist" :class="{ contiphonex: this.systemInfo.isPhoneX }">
        <h1 class="tips">审核通过的申报，将展示在首页，您也可以把项目分享给好友</h1>
        <div class="listcontent">
          <ul class="listul">
            <li @click="forDetail(item)" tag="li" class="listli" v-for="(item, index) in this.myWorkList" :key="index">
              <div class="newsinfo">
                <div class="newsimg">
                  <!-- 作品有图片时的缩略图 -->
                  <img v-lazy="item.cover" />
                  <span
                    class="supplement"
                    v-if="
                      worksTypeList &&
                        worksTypeList.length > 0 &&
                        (!item.worksType || JSON.stringify(item.worksType) == '{}') &&
                        item.reviewStatus !== 'REJECT' &&
                        item.reviewStatus !== 'REVOKE'
                    "
                    >补充作品类型</span
                  >
                  <span
                    class="workstype"
                    v-if="item.worksType && JSON.stringify(item.worksType) !== '{}'"
                    :style="{ background: item.worksType.color }"
                    >{{ item.worksType.typeName }}</span
                  >
                  <span class="tag-money" v-if="item.reward && item.reward.isReward === 'YES'">
                    稿费
                    <span class="orange">¥{{ item.reward.bonus | resolveBouns }}</span>
                  </span>
                  <i class="icon-play" v-if="item.videos && item.videos.length > 0"></i>
                </div>
                <div class="newsword">
                  <div class="newstitle">{{ item.title }}</div>
                  <div class="newstime">{{ item.createTime.slice(0, -3) }}</div>
                  <div class="vewsoption">
                    <div class="newsstatus">
                      <div class="status">{{ resolveExamine(item).statusText }}</div>
                      <div
                        class="seeseason"
                        v-if="showNoPassReason(resolveExamine(item).status, resolveExamine(item).remark)"
                        @click.stop="showSeason(resolveExamine(item).remark)"
                      >
                        查看原因
                      </div>
                      <!-- <div class="thumbers" v-if="item.verifyStatus == 2"> -->
                      <div class="thumbers" v-if="resolveExamine(item).status === 'PASS' && !hidePraise">
                        <img src="../..//assets/images/icon_like_s.png" alt />
                        {{ item.likeNum | NumFormat }}
                      </div>
                    </div>
                    <!-- <div class="newsbtn fx" v-if="item.verifyStatus == 2" @click.stop="sharewx(item)">
                      分享
                    </div>-->
                    <div class="newsbtn fx" @click.stop="sharewx(item)" v-if="systemInfo.isNfPlus && item.reviewStatus == 'PASS'">分享</div>
                    <div class="newsbtn xg" v-if="showRevise(resolveExamine(item).status)" @click.stop="share(item)">修改</div>
                  </div>
                </div>
              </div>
            </li>
          </ul>
        </div>
        <!-- 没有数据显示 -->
        <template v-if="showNoWorkData">
          <NoWorksData v-show="showNoWorkData" />
        </template>
        <template v-else>
          <BottomLoading :showNoMore="noMoremyWorkList" />
        </template>
      </div>
    </div>
    <div class="noUserinfo" :style="{ height: screenHeight + 'px', width: screenWidth + 'px' }" v-if="!this.hasPerfectedUserInfo">
      <div class="bg"></div>
      <p>暂无申报</p>
    </div>
    <div class="contribute_box" style="font-size: 16px;" :class="{ iphonex: this.systemInfo.isPhoneX }">
      <div class="contribute" @click="handleJumpPage('contribute')" v-if="contributeStatus">添加申报</div>
      <div class="contribute works-list" @click="handleJumpMyWorkCollection" v-if="this.hasPerfectedUserInfo">分享</div>
    </div>
    <seasonbox :show="showItemseason" :rejectseason="rejectseason" @input="closeSeason"></seasonbox>
  </div>
</template>

<script>
import BottomLoading from "@/components/BottomLoading"
import seasonbox from "@/components/SeasonBox/index"
import NoWorksData from "@/components/NoWorksData"
import Button from "./components/Button"
import noImage from "@/assets/images/zhanweitu.png"
import getUserInfo from "@/mixins/getUserInfo"
import resolveUserUnit from "@/utils/resolveUserUnit"
import { EXAMINE_TYPE_MAP } from "@/dictionary"
import { mapActions, mapGetters, mapMutations } from "vuex"
import { buryingPoint_myWork } from "@/server/buryingPoint"

export default {
  name: "myWork",
  components: {
    BottomLoading,
    NoWorksData,
    seasonbox,
    Button
  },
  data() {
    return {
      page: 0,
      size: 10,
      showwx: false,
      coverImg: "",
      screenHeight: 0,
      screenWidth: 0,
      showItemseason: false,
      rejectseason: "",
      background: "#EF9F28",
      worksTypeList: [] //作品类型列表数据
    }
  },
  created() {
    if (!this.hasPerfectedUserInfo) {
      this.getUserDetail()
    }
    this.getUserDetail()
    this.init()
    buryingPoint_myWork()
  },
  mounted() {
    this.worksTypeList = this.allWorksTypes.filter(item => {
      return item.display == "YES"
    })
    this.screenHeight = document.documentElement.clientHeight
    this.screenWidth = document.documentElement.clientWidth
  },
  mixins: [getUserInfo],
  methods: {
    ...mapMutations({
      setworkDetail: "workDetail/setworkDetail",
      showLoading: "loading/showLoading",
      hideLoading: "loading/hideLoading",
      modifyworkDetail: "myWork/modifyworkDetail",
      setNextRouteName: "userInfo/setNextRouteName",
      setUnShowHead: "userInfo/setUnShowHead",
      showOpenApp: "showOpenApp"
    }),
    ...mapActions({
      getUserInfoBindPhone: "userInfo/getUserInfoBindPhone",
      getUserDetail: "userInfo/getUserDetail",
      getmyWorkList: "myWork/getmyWorkList",
      getCertTipsCount: "cert/getCertTipsCount",
      getCertGroup: "cert/getCertGroup"
    }),
    // 点击修改按钮
    share(item) {
      this.modifyworkDetail(item)
      this.$router.push({ name: "contribute", params: { edit: true, conbute: true }, query: { workId: item.id } })
    },
    // 点击查看不通过原因
    showSeason(remark) {
      document.querySelector("#app").style.overflow = "hidden"
      this.showItemseason = true
      this.rejectseason = remark
    },
    closeSeason() {
      this.showItemseason = false
    },
    //点击分享按钮
    sharewx(item) {
      const mediaFiles = (item.mediaFiles || []).filter(item => item.mediaFileType === "PICTURE")
      const videos = (item.videos || []).filter(item => item.mediaFileType === "VIDEO")
      const mediaCoverItem = mediaFiles.find(item => item.cover)
      const mediaCover = mediaCoverItem ? mediaCoverItem.url : ""
      const defaultMediaCover = mediaFiles[0] ? mediaFiles[0].url : ""
      const videoCover = videos[0] ? videos[0].coverImgUrl : ""
      const cover = mediaCover || videoCover || defaultMediaCover || item.worksDefaultPic
      this.coverImg = cover || "https://static.nfapp.southcn.com/app/nanfang_logo.png"
      const origin = window.location.origin
      const pathname = window.location.pathname
      // window.nfplusJsbridge.share({
      //   title: item.title,
      //   content: this.activityDetailDesc.singleShareDesc + item.NAME + item.SCHOOL + item.GRADE + item.detail,
      //   icon: this.coverImg,
      //   url: `${origin}${pathname}?route=workDetail&workId=${item.id}&id=${item.activityId}`
      // })
      let worksTypeName = item.worksType && item.worksType.typeName ? item.worksType.typeName + " | " : ""
      let shareDes = (item.defaultOpt ? (item.defaultOpt.company ? `${item.defaultOpt.company.companyName} ` : "") : "") + item.detail
      if (
        (item.userName || (item.school && item.school.schoolName) || (item.grade && item.grade.gradeName)) &&
        this.activityDetailDesc.singleShareDesc
      ) {
        window.nfplusJsbridge.share({
          title: worksTypeName + item.title,
          content: shareDes,
          // `${this.activityDetailDesc.singleShareDesc}（ ${item.userName} ${item.school ? item.school.schoolName : ""}${
          //   item.grade ? item.grade.gradeName : ""
          // }）${item.detail} `,
          icon: this.coverImg,
          url: `${origin}${pathname}?route=workDetail&workId=${item.id}&id=${item.activityId}`
        })
      }
      if (
        this.activityDetailDesc.singleShareDesc &&
        !item.userName &&
        !(item.school && item.school.schoolName) &&
        !(item.grade && item.grade.gradeName)
      ) {
        window.nfplusJsbridge.share({
          title: worksTypeName + item.title,
          content: shareDes,
          // `${this.activityDetailDesc.singleShareDesc} ${item.detail} `,
          icon: this.coverImg,
          url: `${origin}${pathname}?route=workDetail&workId=${item.id}&id=${item.activityId}`
        })
      }
      if (!this.activityDetailDesc.singleShareDesc) {
        window.nfplusJsbridge.share({
          title: worksTypeName + item.title,
          content: shareDes,
          // `${item.userName} ${item.school ? item.school.schoolName : ""}${item.grade ? item.grade.gradeName : ""} ${item.detail}`,
          icon: this.coverImg,
          url: `${origin}${pathname}?route=workDetail&workId=${item.id}&id=${item.activityId}`
        })
      }
    },
    forDetail(item) {
      this.$router.push({ path: "/workDetail", query: { workId: item.id } })
    },
    closeshare() {
      this.showwx = !this.showwx
    },
    modifyingdata() {
      this.$router.push({ path: "/userInfo" })
      // window.console.log(this.userdetail.id)
    },
    //点击投稿按钮跳转投稿页面
    // immediately() {
    //   this.$router.push({ path: "/contribute" })
    // },
    async handleJumpPage(routeName) {
      const isNfPlus = this.systemInfo.isNfPlus
      if (!isNfPlus) {
        this.showOpenApp("请打开南方+报名或查看我的申报")
        return
      } else {
        const hasUserInfo = await this.getUserInfoBindPhone()
        if (!hasUserInfo) return
        if (routeName === "contribute") {
          this.handleJumpContribute(routeName)
          return
        }
        hasUserInfo && this.$router.push({ name: "contribute", params: { conbute: true } })
      }
    },
    async handleJumpContribute(routeName) {
      let hasPerfectedUserInfo = this.hasPerfectedUserInfo
      if (!hasPerfectedUserInfo) {
        await this.getUserDetail()
        hasPerfectedUserInfo = this.hasPerfectedUserInfo
      }
      if (hasPerfectedUserInfo) {
        this.$router.push({ name: routeName, params: { conbute: true } })
      } else {
        this.setNextRouteName("contribute")
        this.setUnShowHead(true)
        this.$router.push({ name: "userInfo" })
      }
    },
    worklist() {
      this.getmyWorkList({ params: { page: this.page, size: this.size } })
    },
    scrollEnd() {},

    // 触底刷新
    async init() {
      this.showLoading()
      this._getCertGroup()
      // await this.getActivityInfo({ showLoading: false })
      await this._getWorksList()
      this.hideLoading()
      // this.getCertTipsCount()
    },
    // 判断是否滚动到底部
    uploadMore() {
      const myworkDom = this.$refs.myworkWrapper
      //卷起的高度
      const scrollTop = myworkDom.scrollTop
      // const myworkScrollHeight = myworkDom.scrollHeight
      // 页面整体的高度
      const myworkOffsetHeight = myworkDom.offsetHeight
      const scrollHeight = myworkDom.scrollHeight
      // window.innerHeight  窗口可视区域的高度
      const isToBottom = scrollHeight - 5 <= myworkOffsetHeight + scrollTop
      isToBottom && this.handleLoadMore()
    },
    handleLoadMore() {
      // @TODO 判断是否没有跟多数据或者正在加载中，等接口一起判断
      // window.console.log("加载更多----")
      // window.console.log(this.noMoremyWorkList)
      if (!this.noMoremyWorkList && !this.loadingWorksList) {
        this.page++
        this._getWorksList(false)
      }
    },
    scroll(e) {
      // 优化移动端window.onscroll的执行频率方案
      if (this.scrollTimer) {
        window.clearTimeout(this.scrollTimer)
        this.scrollTimer = null
      }
      this.scrollTimer = window.setTimeout(() => {
        this.uploadMore(e)
      }, 17)
    },
    async _getWorksList(showLoading = true) {
      const params = {
        params: { page: this.page, size: this.size },
        finalFunc: () => {
          this.loadingWorksList = false
        },
        showLoading
      }
      this.loadingWorksList = true
      await this.getmyWorkList(params)
    },
    resolveExamine(workInfo) {
      if (!workInfo) return ""
      const fistReview = workInfo.firstReview || {}
      const finalReview = workInfo.finalReview || {}
      const firstReview_reviewStatusEnum = fistReview.reviewStatusEnum
      const finalReview_reviewStatusEnum = finalReview.reviewStatusEnum
      const finalRevie_handlers = {
        WAIT: () => {
          return {
            statusText: EXAMINE_TYPE_MAP[firstReview_reviewStatusEnum] || EXAMINE_TYPE_MAP[finalReview_reviewStatusEnum],
            status: firstReview_reviewStatusEnum ? firstReview_reviewStatusEnum : finalReview_reviewStatusEnum,
            remark: fistReview.remark
          }
        },
        PASS: () => ({ statusText: EXAMINE_TYPE_MAP["PASS"], status: "PASS" }),
        REJECT: () => ({ statusText: EXAMINE_TYPE_MAP["REJECT"], status: "REJECT", remark: finalReview.remark }),
        REVOKE: () => ({ statusText: EXAMINE_TYPE_MAP["REVOKE"], status: "REVOKE", remark: finalReview.remark })
      }
      const fistReview_handlers = {
        WAIT: () => ({ statusText: EXAMINE_TYPE_MAP["WAIT"], status: "WAIT" }),
        FIRST_PASS: () => ({ statusText: EXAMINE_TYPE_MAP["FIRST_PASS"], status: "FIRST_PASS" }),
        FIRST_REJECT: () => ({ statusText: EXAMINE_TYPE_MAP["FIRST_REJECT"], status: "FIRST_REJECT", remark: fistReview.remark })
      }
      const handler = finalRevie_handlers[finalReview_reviewStatusEnum] || fistReview_handlers[firstReview_reviewStatusEnum]
      const result = handler()
      return result
    },
    showNoPassReason(status, remark) {
      const showNoPassReasonMap = {
        REVOKE: remark,
        REJECT: remark,
        FIRST_REJECT: remark
      }
      return showNoPassReasonMap[status]
    },
    showRevise(status) {
      const showReviseMap = {
        REVOKE: 1,
        REJECT: 1,
        FIRST_REJECT: 1,
        WAIT: 1
      }
      return showReviseMap[status]
    },
    handleJumpMyWorkCollection() {
      const query = {
        userId: this.userInfo.userId
      }
      this.$router.push({ path: "/workCollection", query })
    },
    handleJumpCertGroup() {
      this.$router.push({ path: "/certGroup" })
    },
    async _getCertGroup() {
      await this.getCertGroup()
    }
  },
  computed: {
    ...mapGetters({
      userInfo: "userInfo/userInfo",
      hasPerfectedUserInfo: "userInfo/hasPerfectedUserInfo",
      noMoremyWorkList: "myWork/noMoremyWorkList",
      myWorkList: "myWork/myWorkList",
      indexNavigations: "activityInfo/indexNavigations",
      systemInfo: "systemInfo",
      activityDetailDesc: "activityInfo/activityDetailDesc",
      allWorksTypes: "activityInfo/allWorksTypes",
      contributeStatus: "activityInfo/contributeStatus",
      hidePraise: "activityInfo/hidePraise",
      myCertTipsCount: "cert/myCertTipsCount",
      certGroup: "cert/certGroup"
    }),
    showNoWorkData() {
      return this.myWorkList.length < 1
    },
    powericon() {
      return this.userInfo.headImg ? this.userInfo.headImg : noImage
    },
    userUnit() {
      return resolveUserUnit(this.userInfo)
    },
    showMyCertButton() {
      return this.certGroup.length > 0
    }
  },
  filters: {
    //数字过滤器，每三个逗号断开
    NumFormat: function(value) {
      if (!value) return 0
      value = String(value)
      if (value.length > 0 && value.length < 5) {
        const intPart = Number(value) | 0 //获取整数部分
        const intPartFormat = intPart.toString().replace(/(\d)(?=(?:\d{3})+$)/g, "$1,") //将整数部分逢三一断
        return intPartFormat
      }
      if (value.length >= 5 && value.length < 9) {
        const intPart = Number(value) | 0 //获取整数部分
        const n = Math.floor((intPart / 10000) * 100) / 100
        const intPartFormat = n.toString().replace(/(\d)(?=(?:\d{3})+$)/g, "$1,") //将整数部分逢三一断
        return intPartFormat + "万"
      }
    },
    resolveBouns(value) {
      if (!value) return 0
      return value / 100
    }
  }
}
</script>
<style lang="scss" scoped>
.mywork {
  padding-bottom: 0.4rem;
  height: 100%;
  width: 100%;
  overflow: auto;
  .headimg {
    width: 100%;
    padding: 0 0.4rem;
    .useinfo {
      border-bottom: 1px solid #eeeeee;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      padding: 0.3rem 0;
      .useimg {
        width: 1rem;
        height: 1rem;
        border-radius: 50%;
        overflow: hidden;
        img {
          width: 100%;
          height: 100%;
        }
      }
      .allinfo {
        width: calc(100% - 1rem);
        padding-left: 0.2rem;
        .infotop {
          display: flex;
          justify-content: space-between;
          align-items: center;
          .namegrade {
            display: flex;
            justify-content: flex-start;
            align-items: center;
            .usename {
              font-family: PingFangSC-Regular;
              font-size: 0.32rem;
              color: #333333;
              letter-spacing: 0;
              line-height: 0.45rem;
              overflow: hidden;
              word-break: break-all;
              white-space: wrap;
              text-overflow: ellipsis;
              display: -webkit-box;
              -webkit-line-clamp: 1;
              -webkit-box-orient: vertical;
            }
            .usegrade {
              font-family: PingFangSC-Regular;
              font-size: 0.24rem;
              color: #666666;
              letter-spacing: 0;
              min-width: 1.2rem;
            }
            .usegrade::before {
              content: "";
              background: #cccccc;
              display: inline-block;
              letter-spacing: 0;
              margin: 0 0.15rem;
              height: 0.18rem;
              width: 1px;
            }
          }
          .modifyingdata {
            width: 1.5rem;
            height: 0.36rem;
            background: rgba(56, 155, 238, 0.1);
            border: 1px solid #389bee;
            border-radius: 0.205rem;
            text-align: center;
            font-family: PingFangSC-Regular;
            font-size: 0.22rem;
            color: #389bee;
            letter-spacing: 0;
            line-height: 0.36rem;
          }
          .btn-wrapper {
            flex: none;
            display: flex;
            ::v-deep .ui-button-wrapper {
              margin-left: 0.2rem;
            }
          }
        }
        .useaddress {
          width: 100%;
          font-family: PingFangSC-Regular;
          font-size: 0.24rem;
          color: #666666;
          letter-spacing: 0;
          margin-top: 0.15rem;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }
    }
    .totalverify {
      display: flex;
      justify-content: space-around;
      align-items: center;
      width: 100%;
      height: 1rem;
      .allverify {
        width: 50%;
        text-align: center;
        font-family: PingFangSC-Regular;
        font-size: 0.24rem;
        color: #999999;
        letter-spacing: 0;
        line-height: 0.4rem;
        span {
          font-family: PingFangSC-Regular;
          font-size: 0.28rem;
          color: #f64e45;
          letter-spacing: 0;
          line-height: 0.4rem;
          font-weight: bold;
        }
      }
      .separate {
        font-family: PingFang-SC-Bold;
        font-size: 0.24rem;
        color: #666666;
        letter-spacing: 0;
      }
    }
  }
  .verifylist {
    width: 100%;
    padding-bottom: 0.8rem;
    .tips {
      width: 100%;
      height: 0.64rem;
      font-family: PingFangSC-Regular;
      font-size: 0.24rem;
      color: #999999;
      letter-spacing: 0;
      text-align: center;
      background: #eeeeee;
      line-height: 0.64rem;
      font-weight: normal;
    }
    .listcontent {
      padding: 0 0.3rem;
      .listul {
        .listli {
          .newsinfo {
            border-bottom: 1px solid #eeeeee;
            display: flex;
            justify-content: flex-start;
            align-items: center;
            padding: 0.3rem 0;
            .newsimg {
              width: 1.5rem;
              height: 1.5rem;
              border-radius: 0.1rem;
              position: relative;
              img {
                width: 100%;
                height: 100%;
                object-fit: cover;
                background: #eeeeee;
                border-radius: 0.1rem;
              }
              .supplement {
                position: absolute;
                bottom: 0;
                left: 0;
                font-family: PingFangSC-Regular;
                font-size: 0.22rem;
                color: #ffffff;
                letter-spacing: 0;
                line-height: 0.4rem;
                background: rgba(0, 0, 0, 0.6);
                display: block;
                width: 100%;
                text-align: center;
              }
              .workstype {
                position: absolute;
                bottom: 0;
                right: 0;
                max-width: 95%;
                font-family: PingFangSC-Regular;
                font-size: 0.22rem;
                color: #ffffff;
                letter-spacing: 0;
                line-height: 0.4rem;
                display: block;
                padding: 0 0.1rem;
                border-radius: 0.1rem 0 0 0;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                box-sizing: border-box;
              }
              .tag-money {
                background: rgba(0, 0, 0, 0.7);
                border-radius: 8px 8px 8px 0px;
                padding: 0 0.09rem;
                height: 0.32rem;
                font-family: PingFang-SC-Medium;
                font-size: 0.22rem;
                color: #ffffff;
                letter-spacing: 0;
                line-height: 0.32rem;
                position: absolute;
                top: -0.16rem;
                left: -0.045rem;
              }
              .icon-play {
                display: inline-block;
                width: 0.44rem;
                height: 0.44rem;
                position: absolute;
                top: 0.4rem;
                left: 50%;
                transform: translate3d(-50%, 0, 0);
                background: url("../../assets/images/icon_vedio.png") no-repeat center;
                background-size: 100%;
              }
            }
            .newsword {
              width: calc(100% - 1.5rem);
              padding-left: 0.2rem;
              .newstitle {
                width: 100%;
                font-family: PingFangSC-Regular;
                font-size: 0.36rem;
                color: #333333;
                letter-spacing: 0;
                line-height: 0.5rem;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
              }
              .newstime {
                font-family: PingFangSC-Regular;
                font-size: 0.26rem;
                color: #666666;
                letter-spacing: 0;
                line-height: 0.37rem;
                margin: 0.1rem 0;
              }
              .vewsoption {
                display: flex;
                justify-content: space-between;
                align-items: center;
                .newsstatus {
                  display: flex;
                  justify-content: flex-start;
                  align-items: center;
                  .status {
                    font-family: PingFangSC-Regular;
                    font-size: 0.26rem;
                    color: #999999;
                    letter-spacing: 0;
                    line-height: 0.37rem;
                    margin-right: 0.4rem;
                  }
                  .adopt {
                    color: #999999 !important;
                  }
                  .seeseason {
                    font-family: PingFangSC-Regular;
                    font-size: 0.26rem;
                    line-height: 0.3rem;
                    color: #43a0ff;
                    letter-spacing: 0;
                    padding-right: 0.3rem;
                    background: url(../../assets/images/icon_arrow_blue.png) no-repeat center right;
                    background-size: 0.3rem 0.3rem;
                  }
                  .thumbers {
                    font-family: PingFangSC-Regular;
                    font-size: 0.24rem;
                    color: #666666;
                    letter-spacing: 0;
                    line-height: 0.33rem;
                    img {
                      width: 0.22rem;
                      height: 0.2rem;
                    }
                  }
                }
                .newsbtn {
                  width: 1.05rem;
                  height: 0.5rem;
                  background: #389bee;
                  border-radius: 20px;
                  font-family: PingFang-SC-Bold;
                  font-size: 0.26rem;
                  color: #ffffff;
                  letter-spacing: 0;
                  line-height: 0.5rem;
                  text-align: center;
                }
                .fx {
                  background: #389bee;
                }
                .xg {
                  background: #4dc170;
                }
              }
            }
          }
        }
      }
      .nomore {
        font-family: PingFangSC-Regular;
        font-size: 0.28rem;
        color: #999999;
        letter-spacing: 0;
        text-align: center;
        line-height: 0.4rem;
        margin: 0.2rem 0;
      }
    }
  }
  .contribute_box {
    position: fixed;
    z-index: 999;
    bottom: 0;
    left: 0;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    background: #ffffff;
    padding: 0.2rem 0.5rem;
    .contribute {
      flex: none;
      margin-right: 0.19rem;
      width: 3.15rem;
      height: 0.88rem;
      background: #389bee;
      border-radius: 0.44rem;
      text-align: center;
      line-height: 0.88rem;
      font-family: PingFangSC-Regular;
      font-size: 0.3rem;
      color: #ffffff;
      letter-spacing: 0;
      &.works-list {
        background: #f64e45;
      }
      &:last-child {
        margin-right: 0;
      }
    }
  }
  .noUserinfo {
    width: 100%;
    height: 100%;
    background: #ffffff;
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    .bg {
      background: url("../../assets/images/common_graphy_nowork@2x.png") no-repeat center;
      background-size: 100% 100%;
      width: 1.8rem;
      height: 1.8rem;
      margin-bottom: 0.1rem;
    }
    p {
      font-family: PingFangSC-Regular;
      font-size: 0.32rem;
      color: #999999;
      letter-spacing: 0;
      text-align: center;
    }
  }
  .iphonex {
    padding-bottom: 34px;
  }
  .contiphonex {
    padding-bottom: 1.2rem;
  }
}
.orange {
  color: #ffdc67;
}
</style>
